import React, { useState, useEffect, useCallback } from "react";
// CSS alag rahegi - apni existing file import karo
// import "../Content/CSS/f_style.css";

// ══════════════════════════════════════════════
// BAGGAGE OFFCANVAS COMPONENT
// Original JS: specialServiceBaggage / specialServiceBaggageB2C
// ══════════════════════════════════════════════

const BAGGAGE_IMAGES = {
  "3KG": "/Content/Images/Baggage/baggage-size-2.jpg",
  "5KG": "/Content/Images/Baggage/baggage-size-4.jpg",
  "8KG": "/Content/Images/Baggage/baggage-size-3.jpg",
  "10KG": "/Content/Images/Baggage/baggage-size-1.jpg",
  "15KG": "/Content/Images/Baggage/baggage-size-6.jpg",
  "30KG": "/Content/Images/Baggage/baggage.png",
};
const DEFAULT_BAGGAGE_IMG = "/Content/Images/Baggage/NoBaggage.svg";

function getBaggageImage(weight) {
  return BAGGAGE_IMAGES[weight] || DEFAULT_BAGGAGE_IMG;
}

// ─── BaggageRow ───────────────────────────────
function BaggageRow({ baggage, paxType, paxIndex, optionIndex, isChecked, onChange }) {
  const inputId = `baggage-pax-${paxType}-${paxIndex}-baggage-${optionIndex + 1}`;
  const name = `baggageoption-${paxType}-${paxIndex}`;

  return (
    <div className="baggage_row">
      <div className="baggage_col">
        <div className="baggage_img">
          <img src={getBaggageImage(baggage.Weight)} alt="baggage" />
        </div>
        <div>
          <span className="baggage_desc">{baggage.Description}</span>
          <span className="baggage_price">₹{baggage.Price}</span>
        </div>
      </div>
      <div className="baggage_col">
        <input
          className="baggage_rbtn"
          id={inputId}
          type="checkbox"
          name={name}
          checked={isChecked}
          data-price={baggage.Price}
          data-code={baggage.Code}
          onChange={() => onChange(paxType, paxIndex, baggage)}
        />
        <label htmlFor={inputId}></label>
      </div>
    </div>
  );
}

// ─── BaggagePaxBlock ──────────────────────────
function BaggagePaxBlock({ label, paxType, paxIndex, baggageList, selection, onToggle, collapseId, expanded }) {
  const [open, setOpen] = useState(expanded);
  const selectedBaggage = selection[`${paxType}-${paxIndex}`];
  const price = selectedBaggage ? selectedBaggage.Price : 0;

  return (
    <>
      <div
        className="baggage_pax"
        onClick={() => setOpen((o) => !o)}
        style={{ cursor: "pointer" }}
      >
        <div><span className="lbl">{label}</span></div>
        <div>
          <span className="lbl baggage-price-label">₹{price}</span>
          <span className="lbl2">Added to fare</span>
        </div>
      </div>
      <div className={`collapse${open ? " show" : ""}`} id={collapseId}>
        <div className="baggage_list">
          {baggageList.map((baggage, idx) => (
            <BaggageRow
              key={idx}
              baggage={baggage}
              paxType={paxType}
              paxIndex={paxIndex}
              optionIndex={idx}
              isChecked={selectedBaggage?.Code === baggage.Code}
              onChange={onToggle}
            />
          ))}
        </div>
      </div>
    </>
  );
}

// ─── BaggageOffcanvas (main) ──────────────────
export function BaggageOffcanvas({
  contractId,
  returnContractId = null,
  isInternational = false, // SSReturnBaggageINTB2C
  onDone,
}) {
  const [baggageData, setBaggageData] = useState({
    BaggageList: [],
    ReturnBaggageList: [],
    PaxDetails: { NumberOFadult: 0, NumberOFChild: 0, NumberOFInfant: 0 },
    sourceCity: "",
    destinationCity: "",
  });
  const [loading, setLoading] = useState(false);
  // selection: { "adult-1": { Code, Price }, "child-1": {...}, "returnadult-1": {...} }
  const [selection, setSelection] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("baggageSelection") || "{}");
    } catch {
      return {};
    }
  });
  const [childSelection, setChildSelection] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("baggageSelectionChild") || "{}");
    } catch {
      return {};
    }
  });

  useEffect(() => {
    if (!contractId) return;
    setLoading(true);

    const body = returnContractId
      ? { contractId_: contractId, returnContractId_: returnContractId }
      : { contractId_: contractId };

    fetch("/AirResponse/specialService", {
      method: "POST",
      headers: { "Content-Type": "application/json; charset=utf-8" },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((res) => {
        setBaggageData({
          BaggageList: res.BaggageList || [],
          ReturnBaggageList: res.ReturnBaggageList || [],
          PaxDetails: {
            NumberOFadult: res.PaxDetails?.NumberOFadult || 0,
            NumberOFChild: res.PaxDetails?.NumberOFChild || 0,
            NumberOFInfant: res.PaxDetails?.NumberOFInfant || 0,
          },
          sourceCity: res.BaggageList?.[0]?.Origin || "",
          destinationCity: res.BaggageList?.[0]?.Destination || "",
        });
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [contractId, returnContractId]);

  const handleToggle = useCallback((paxType, paxIndex, baggage) => {
    const key = `${paxType}-${paxIndex}`;
    const isChild = paxType.includes("child");

    const setter = isChild ? setChildSelection : setSelection;
    const storageKey = isChild ? "baggageSelectionChild" : "baggageSelection";

    setter((prev) => {
      const next = { ...prev };
      // Toggle: if same code already selected → deselect
      if (next[key]?.Code === baggage.Code) {
        delete next[key];
      } else {
        next[key] = { Code: baggage.Code, Price: baggage.Price };
      }
      try {
        localStorage.setItem(storageKey, JSON.stringify(next));
      } catch {}

      // Sync hidden inputs
      syncBaggageInputs(next, isChild);
      return next;
    });
  }, []);

  function syncBaggageInputs(sel, isChild) {
    const str = Object.entries(sel)
      .map(([key, val]) => `${key}-${val.Code}-${val.Price}`)
      .join("|");
    const inputId = isChild ? "childbaggage" : "adultbaggage";
    const el = document.getElementById(inputId);
    if (el) el.value = str;
  }

  const totalPrice = [
    ...Object.values(selection),
    ...Object.values(childSelection),
  ].reduce((sum, v) => sum + (Number(v.Price) || 0), 0);

  const handleDone = () => {
    const el = document.getElementById("BaggagePrice");
    if (el) el.value = totalPrice;
    if (onDone) onDone(totalPrice);
  };

  const { BaggageList, ReturnBaggageList, PaxDetails } = baggageData;
  const adults = Array.from({ length: PaxDetails.NumberOFadult }, (_, i) => i + 1);
  const children = Array.from({ length: PaxDetails.NumberOFChild }, (_, i) => i + 1);

  return (
    <div className="offcanvas offcanvas-end show" tabIndex="-1" id="baggage-offcanvas" style={{ width: 500, maxWidth: "96vw" }}>
      <div className="offcanvas-header border-bottom">
        <h5>Add in-flight baggage to your journey</h5>
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
      </div>
      <div className="offcanvas-body p-4">
        {loading && <div className="text-center py-5"><div className="spinner-border" /></div>}

        {!loading && (
          <div className="adon_wrap">
            <div className="adon_left" id="SourceDestiBaggage">
              {baggageData.sourceCity && (
                <div className="vtab_btn active">
                  <span className="vtab_trip">
                    {baggageData.sourceCity}
                    <i className="bi bi-arrow-right" />
                    {baggageData.destinationCity}
                  </span>
                  <span className="vtab_traveler">
                    <span>{Object.keys({ ...selection, ...childSelection }).length}</span>
                    /{PaxDetails.NumberOFadult + PaxDetails.NumberOFChild}
                  </span>
                </div>
              )}
            </div>
            <div className="adon_right">
              <div id="pexdetails">
                {/* Adults - Onward */}
                {adults.map((i) => (
                  <BaggagePaxBlock
                    key={`adult-${i}`}
                    label={`Adult ${i}`}
                    paxType="adult"
                    paxIndex={i}
                    baggageList={BaggageList}
                    selection={selection}
                    onToggle={handleToggle}
                    collapseId={`baggage-onward-pax-${i}`}
                    expanded={i === 1}
                  />
                ))}
                {/* Adults - Return (if international) */}
                {isInternational && ReturnBaggageList.length > 0 &&
                  adults.map((i) => (
                    <BaggagePaxBlock
                      key={`returnadult-${i}`}
                      label={`Adult ${i} - Return`}
                      paxType="returnadult"
                      paxIndex={i}
                      baggageList={ReturnBaggageList}
                      selection={selection}
                      onToggle={handleToggle}
                      collapseId={`baggage-return-pax-${i}`}
                      expanded={false}
                    />
                  ))}
                {/* Children - Onward */}
                {children.map((i) => (
                  <BaggagePaxBlock
                    key={`child-${i}`}
                    label={`Child ${i}`}
                    paxType="child"
                    paxIndex={i}
                    baggageList={BaggageList}
                    selection={childSelection}
                    onToggle={handleToggle}
                    collapseId={`baggage-onward-child-${i}`}
                    expanded={false}
                  />
                ))}
                {/* Children - Return (if international) */}
                {isInternational && ReturnBaggageList.length > 0 &&
                  children.map((i) => (
                    <BaggagePaxBlock
                      key={`returnchild-${i}`}
                      label={`Child ${i} - Return`}
                      paxType="returnchild"
                      paxIndex={i}
                      baggageList={ReturnBaggageList}
                      selection={childSelection}
                      onToggle={handleToggle}
                      collapseId={`baggage-return-child-${i}`}
                      expanded={false}
                    />
                  ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="offcanvas-bottom p-3 shadow">
        <div className="d-flex justify-content-end align-items-center gap-3">
          <span className="fs-5 fw-semibold">₹{totalPrice}</span>
          <button
            className="btn btn-primary px-4"
            id="btnbaggage"
            onClick={handleDone}
            data-bs-dismiss="offcanvas"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════
// MEAL OFFCANVAS COMPONENT
// Original JS: specialServiceMeal / specialServiceMealB2C / SSReturnMeal / SSReturnMealB2C
// ══════════════════════════════════════════════

function getMealImage(mealCode, airlineCode) {
  const map = {
    VGML: "CJSW",
    VCSW: "PTSW",
    PTSW: "JNML",
    CHBR: "DBVG",
    AGSW: "VGAN",
    NUSW: "LCVG",
    CJSW: "CHBR",
    CPML: "CHBR",
  };
  const prefix = map[mealCode];
  if (prefix && airlineCode)
    return `/Content/Images/Meal/${airlineCode}/${prefix}_${airlineCode}_MEAL.gif`;
  return "/Content/Images/Meal/Meal.svg";
}

// ─── MealRow ──────────────────────────────────
function MealRow({ meal, paxType, paxIndex, mealIndex, isReturn, isChecked, onChange, airlineCode }) {
  const prefix = isReturn
    ? `meal-${paxType}-${paxIndex}-return`
    : `meal-${paxType}-${paxIndex}`;
  const inputId = `${prefix}-${mealIndex}`;
  const name = isReturn
    ? `mealoption-return-${paxType}-${paxIndex}`
    : `mealoption-${paxType}-${paxIndex}`;

  return (
    <div className="meal_row">
      <div className="meal_col">
        <div className="meal_img">
          <img src={getMealImage(meal.Code, airlineCode || meal.AirlineCode)} alt="Meal" />
        </div>
        <div>
          <span className="meal_desc">{meal.Description}</span>
          <span className="meal_price">₹{meal.MealAmount}</span>
        </div>
      </div>
      <div className="meal_col">
        <input
          className="meal_rbtn"
          id={inputId}
          type="checkbox"
          name={name}
          checked={isChecked}
          data-price={meal.MealAmount}
          data-code={meal.Code}
          onChange={() => onChange(paxType, paxIndex, isReturn, meal)}
        />
        <label htmlFor={inputId}></label>
      </div>
    </div>
  );
}

// ─── MealPaxBlock ─────────────────────────────
function MealPaxBlock({
  label,
  paxType,
  paxIndex,
  isReturn,
  mealList,
  selection,
  onToggle,
  airlineCode,
}) {
  const [open, setOpen] = useState(!isReturn);
  const key = `${paxType}-${paxIndex}-${isReturn ? "return" : "onward"}`;
  const selectedMeal = selection[key];
  const price = selectedMeal ? selectedMeal.MealAmount : 0;
  const collapseId = isReturn
    ? `meal-return-pax-${paxType}-${paxIndex}-return`
    : `meal-onward-pax-${paxType}-${paxIndex}`;

  return (
    <>
      <div
        className="meal_pax"
        onClick={() => setOpen((o) => !o)}
        style={{ cursor: "pointer" }}
      >
        <div><span className="lbl">{label}</span></div>
        <div>
          <span className={`lbl meal-price-label ${paxType}-price`}>₹{price}</span>
          <span className="lbl2">Added to fare</span>
        </div>
      </div>
      <div className={`collapse${open ? " show" : ""}`} id={collapseId}>
        <div className={`meal_list meal-list-${paxType}${isReturn ? "-return" : ""}`}>
          {mealList.map((meal, idx) => (
            <MealRow
              key={idx}
              meal={meal}
              paxType={paxType}
              paxIndex={paxIndex}
              mealIndex={idx}
              isReturn={isReturn}
              isChecked={selectedMeal?.Code === meal.Code}
              onChange={onToggle}
              airlineCode={airlineCode}
            />
          ))}
        </div>
      </div>
    </>
  );
}

// ─── MealOffcanvas (main) ─────────────────────
export function MealOffcanvas({
  contractId,
  returnContractId = null,
  onDone,
}) {
  const [mealData, setMealData] = useState({
    MealList: [],
    ReturnMealList: [],
    PaxDetails: { NumberOFadult: 0, NumberOFChild: 0, NumberOFInfant: 0 },
    airlineCode: "",
  });
  const [loading, setLoading] = useState(false);
  // selection: { "adult-1-onward": mealObj, "adult-1-return": mealObj }
  const [selection, setSelection] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("mealSelection") || "{}");
    } catch {
      return {};
    }
  });

  useEffect(() => {
    if (!contractId) return;
    setLoading(true);

    const body = returnContractId
      ? { contractId_: contractId, returnContractId_: returnContractId }
      : { contractId_: contractId };

    fetch("/AirResponse/specialService", {
      method: "POST",
      headers: { "Content-Type": "application/json; charset=utf-8" },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((res) => {
        const seatList = res.AirlineSeatMasterList || [];
        setMealData({
          MealList: res.MealList || [],
          ReturnMealList: res.ReturnMealList || [],
          PaxDetails: {
            NumberOFadult: res.PaxDetails?.NumberOFadult || 0,
            NumberOFChild: res.PaxDetails?.NumberOFChild || 0,
            NumberOFInfant: res.PaxDetails?.NumberOFInfant || 0,
          },
          airlineCode: seatList[0]?.AirlineCode || "",
          sourceCity: res.MealList?.[0]?.Origin || "",
          destinationCity: res.MealList?.[0]?.Destination || "",
        });
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [contractId, returnContractId]);

  const handleToggle = useCallback((paxType, paxIndex, isReturn, meal) => {
    const key = `${paxType}-${paxIndex}-${isReturn ? "return" : "onward"}`;

    setSelection((prev) => {
      const next = { ...prev };
      if (next[key]?.Code === meal.Code) {
        delete next[key]; // deselect
      } else {
        next[key] = meal;
      }
      try {
        localStorage.setItem("mealSelection", JSON.stringify(next));
      } catch {}

      syncMealInputs(next, paxType, paxIndex, isReturn);
      return next;
    });
  }, []);

  function syncMealInputs(sel, changedPaxType, changedPaxIndex, isReturn) {
    const { PaxDetails } = mealData;

    function buildString(type, maxCount, isRet) {
      const parts = [];
      for (let i = 1; i <= maxCount; i++) {
        const k = `${type}-${i}-${isRet ? "return" : "onward"}`;
        if (sel[k]) {
          const prefix = isRet ? `${type}-return-${i}` : `${type}-${i}`;
          parts.push(`${prefix}-${sel[k].Code}-${sel[k].MealAmount}`);
        }
      }
      return parts.join("|");
    }

    const adultOnward = buildString("adult", PaxDetails.NumberOFadult, false);
    const adultReturn = buildString("adult", PaxDetails.NumberOFadult, true);
    const childOnward = buildString("child", PaxDetails.NumberOFChild, false);
    const childReturn = buildString("child", PaxDetails.NumberOFChild, true);

    const setInput = (id, val) => {
      const el = document.getElementById(id);
      if (el) el.value = val;
    };

    setInput("adultMeal", adultOnward);
    setInput("adultReturnMeal", adultReturn);
    setInput("childMeal", childOnward);
    setInput("childReturnMeal", childReturn);
  }

  const totalPrice = Object.values(selection).reduce(
    (sum, m) => sum + (Number(m?.MealAmount) || 0),
    0
  );

  const handleDone = () => {
    const el = document.getElementById("MealPrice");
    if (el) el.value = totalPrice;
    if (onDone) onDone(totalPrice);
  };

  const { MealList, ReturnMealList, PaxDetails, airlineCode } = mealData;
  const adults = Array.from({ length: PaxDetails.NumberOFadult }, (_, i) => i + 1);
  const children = Array.from({ length: PaxDetails.NumberOFChild }, (_, i) => i + 1);
  const checkedCount = Object.keys(selection).length;

  return (
    <div className="offcanvas offcanvas-end show" tabIndex="-1" id="meal-offcanvas" style={{ width: 500, maxWidth: "96vw" }}>
      <div className="offcanvas-header border-bottom">
        <h5>Add in-flight meals to your journey</h5>
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
      </div>
      <div className="offcanvas-body p-4">
        {loading && <div className="text-center py-5"><div className="spinner-border" /></div>}

        {!loading && (
          <div className="adon_wrap">
            <div className="adon_left" id="SourceDestiMeal">
              {mealData.sourceCity && (
                <div className="vtab_btn active">
                  <span className="vtab_trip">
                    {mealData.sourceCity}
                    <i className="bi bi-arrow-right" />
                    {mealData.destinationCity}
                  </span>
                  <span className="vtab_traveler">
                    <span>{checkedCount}</span>/{PaxDetails.NumberOFadult + PaxDetails.NumberOFChild}
                  </span>
                </div>
              )}
            </div>
            <div className="adon_right">
              <div id="pexdetailsmeal">
                {/* Adults Onward */}
                {adults.map((i) => (
                  <MealPaxBlock
                    key={`adult-${i}-onward`}
                    label={`Adult ${i}`}
                    paxType="adult"
                    paxIndex={i}
                    isReturn={false}
                    mealList={MealList}
                    selection={selection}
                    onToggle={handleToggle}
                    airlineCode={airlineCode}
                  />
                ))}
                {/* Adults Return */}
                {ReturnMealList.length > 0 &&
                  adults.map((i) => (
                    <MealPaxBlock
                      key={`adult-${i}-return`}
                      label={`Return Adult ${i}`}
                      paxType="adult"
                      paxIndex={i}
                      isReturn={true}
                      mealList={ReturnMealList}
                      selection={selection}
                      onToggle={handleToggle}
                      airlineCode={airlineCode}
                    />
                  ))}
                {/* Children Onward */}
                {children.map((i) => (
                  <MealPaxBlock
                    key={`child-${i}-onward`}
                    label={`Child ${i}`}
                    paxType="child"
                    paxIndex={i}
                    isReturn={false}
                    mealList={MealList}
                    selection={selection}
                    onToggle={handleToggle}
                    airlineCode={airlineCode}
                  />
                ))}
                {/* Children Return */}
                {ReturnMealList.length > 0 &&
                  children.map((i) => (
                    <MealPaxBlock
                      key={`child-${i}-return`}
                      label={`Return Child ${i}`}
                      paxType="child"
                      paxIndex={i}
                      isReturn={true}
                      mealList={ReturnMealList}
                      selection={selection}
                      onToggle={handleToggle}
                      airlineCode={airlineCode}
                    />
                  ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="offcanvas-bottom p-3 shadow">
        <div className="d-flex justify-content-end align-items-center gap-3">
          <span className="fs-5 fw-semibold" id="total-Mealprice">₹{totalPrice}</span>
          <button
            className="btn btn-primary px-4"
            id="btnMeal"
            onClick={handleDone}
            data-bs-dismiss="offcanvas"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}